
import { defineComponent } from 'vue'
import { formatSeconds, fromNow } from '~/utils/date'

/**
 * Sidebar component to show the summary stats of the current run
 *
 */
export default defineComponent({
  name: 'RunSummary',
  props: {
    createdAt: {
      type: String,
      required: true
    },
    finishedIn: {
      type: Number,
      default: 0
    },
    gitCompareDisplay: {
      type: String,
      required: true
    }
  },
  computed: {
    createdString(): string {
      //? If fromNow is passed a falsy value (empty string, undefined, null, etc), it will return Nan years ago
      //? Hence, handled seprately.
      if (this.createdAt) {
        return fromNow(this.createdAt)
      }
      return ''
    },
    finishedString(): string {
      return formatSeconds(this.finishedIn, true)
    },
    metaDataItemList() {
      return [
        {
          key: 'created',
          label: this.createdString,
          icon: 'clock'
        },
        {
          key: 'gitCompareDisplay',
          label: this.gitCompareDisplay,
          icon: 'git-commit'
        },
        {
          key: 'finishedIn',
          label: this.finishedString,
          icon: 'timer'
        }
      ]
    }
  }
})
